import { Box } from '@mui/material';
import React from 'react';

import type { AsyncActionStatus } from '../../actions/common.actionTypes';
import { customSizes } from '../../assets/styles/themes/tokens';
import type { Collection, Pagination } from '../../types/AppContent';
import useScreenSize from '../../utils/useScreenSize';
import OwnCollectionOverviewMainContent from './OwnCollectionOverviewMainContent';
import OwnCollectionOverviewWatchlist from './OwnCollectionOverviewWatchlist';

interface OwnCollectionOverviewBodyProps {
	collectionStatus: AsyncActionStatus;
	collection: Collection;
	collectionId: string;
	collectionPagination: Pagination;
	loadNext: () => void;
}

const OwnCollectionOverviewBody = ({
	collectionStatus,
	collection,
	collectionId,
	collectionPagination,
	loadNext,
}: OwnCollectionOverviewBodyProps) => {
	const { isXsScreen, isSmScreen } = useScreenSize();
	const isMobileScreen = isXsScreen || isSmScreen;

	return (
		<Box
			sx={{
				height: customSizes.ownCollectionOverview.bodyHeight,
				display: 'grid',
				gridTemplateColumns: isMobileScreen
					? '1fr'
					: `1fr ${customSizes.ownCollectionOverview.watchlistWidth}`,
			}}
		>
			<OwnCollectionOverviewMainContent
				collection={collection}
				collectionStatus={collectionStatus}
				collectionId={collectionId}
				collectionPagination={collectionPagination}
				loadNext={loadNext}
			/>
			{!isMobileScreen && <OwnCollectionOverviewWatchlist collection={collection} />}
		</Box>
	);
};

export default OwnCollectionOverviewBody;
